import { Injectable } from '@angular/core';
import { of } from 'rxjs';
import { DeviceTypeService } from '../services/device-type/device-type.service';

@Injectable({
  providedIn: 'root'
})
export class DeviceTypeHelper {
  constructor(private deviceTypeService: DeviceTypeService) {}

  deviceDetection() {
    return of(this.deviceTypeService.getDeviceType());
  }
}
